import React from 'react';

const ThaiMenu = React.forwardRef((props, ref) => {
  return (
    <section ref={ref} id="thaiMenu" className="min-h-screen p-8 text-center">

<h2 className="h2 text-4xl font-bold">Menu and Item Control</h2>
<p className="pretitle text-lg">Enjoying the food before tasting it </p>
<div className='grid grid-row'>
<span>All Menus and Items are added and edited In-App for instant website and in-house ordering changes</span>
<div className=" h9 text-neutral-700 italic underline mt-8 mb-3 ">
Menus </div>
<br/>
<span>In the Menu Editing Screen in the GoHost App, you will find the ability to add/edit menu Names, Descriptions, Pictures, Availability, and Order in which it they are presented on you wesbite.</span>
<br/>
<span>Availability controls whether the Menu populates online or for servers making orders.</span>
</div>

<br/>
<div className=" h9 text-neutral-700 italic underline mt-8 mb-3 ">
Items </div>
<span>In the Item Editing Screen in the GoHost App, you will find the ability to add/edit Names, Descriptions, Pictures, Whether the Picture shows online, Availability, Price, Menu that it pertains to, Food Type and Options. </span>
<br/>
<br/>

<span>"Options" are selectors within each Item that allow variations sizes, quantities, sauces ect. For example, assigning the Glass and Bottle options to the Wine Items below, each with their own pricing. Options for each item can be set to Multiselect, or Singleselect - requiring one selector. </span>
<br/>
<br/> 
<span>"Food Type" can be created for Items that will group similar items within a Menu. For exmaple, if you had a Wine Menu and wanted to split up White and Red, you would create the "White Wine" and "Red Wine" types <span className='pretitle'>like in the Menu below.</span></span>
<br/>
<div className=" h9 text-neutral-700 italic underline mt-8 mb-6 ">
Wine Menu</div>
<p className="pretitle text-lg">White Wine</p>
<div className="grid grid-cols-3 gap-3 mb-8">

<div className=" h9 text-slate-800 italic underline ">
Chardonnay <span className="h7 text-gray-500"></span>
</div>
<div className='text-slate-500 italic underline'>Glass</div>
<div className='text-slate-500 italic underline'>Bottle</div>

<div className="h10 text-2xl text-slate-600 ">
Woodbridge <span className="h7 text-gray-400">California</span>
</div>
<div className='text-slate-500'>7.00</div>
<div className='text-slate-500'>N/A</div>

<div className="h10 text-2xl text-slate-600 ">
Kendall Jackson <span className="h7 text-gray-400">California</span>
</div>
<div className='text-slate-500'>9.75</div>
<div className='text-slate-500'>N/A</div>

<div className="h10 text-2xl text-slate-600 ">
Sonoma Cutrer <span className="h7 text-gray-400">California</span>
</div>
<div className='text-slate-500'>N/A</div>
<div className='text-slate-500'>50</div>

<div className=" mt-6 h9 text-slate-800 italic underline ">
Pinot Grigio <span className="h7 text-gray-500"></span>
</div>
<div className='text-slate-500 italic underline'></div>
<div className='text-slate-500 italic underline'></div>

<div className="h10 text-2xl text-slate-600 ">
Danzante <span className="h7 text-gray-400">Italy</span>
</div>
<div className='text-slate-500'>7.25</div>
<div className='text-slate-500'>27</div>

<div className="h10 text-2xl text-slate-600 ">
Gabbiano <span className="h7 text-gray-400">Italy</span>
</div>
<div className='text-slate-500'>7.00</div>
<div className='text-slate-500'>N/A</div>
</div>

<p className="pretitle text-lg">Red Wine</p>
<div className="grid grid-cols-3 gap-3 mb-8">

<div className=" h9 text-slate-800 italic underline ">
Variety Blend <span className="h7 text-gray-500"></span>
</div>
<div className='text-slate-500 italic underline'>Glass</div>
<div className='text-slate-500 italic underline'>Bottle</div>

<div className="h10 text-2xl text-slate-600 ">
Conundrum <span className="h7 text-gray-400">Zinfandel, Petite Sirah and Cabernet Sauvignon California</span>
</div>
<div className='text-slate-500'>10.00</div>
<div className='text-slate-500'>38</div>

<div className=" mt-6 h9 text-slate-800 italic underline ">
Cabernet Sauvignon <span className="h7 text-gray-500"></span>
</div>
<div className='text-slate-500 italic underline'></div>
<div className='text-slate-500 italic underline'></div>

<div className="h10 text-2xl text-slate-600 ">
Meiomi <span className="h7 text-gray-400">California</span>
</div>
<div className='text-slate-500'>9.00</div>
<div className='text-slate-500'>27</div>

<div className="h10 text-2xl text-slate-600 ">
J.Lorh  <span className="h7 text-gray-400">Paso Robles, CA</span>
</div>
<div className='text-slate-500'>9.25</div>
<div className='text-slate-500'>35</div>

<div className="h10 text-2xl text-slate-600 ">
Justin  <span className="h7 text-gray-400">Paso Robles, CA</span>
</div>
<div className='text-slate-500'>N/A</div>
<div className='text-slate-500'>52</div>
</div>


    </section>

    );
});

export default ThaiMenu;